import React, { useState, useEffect } from "react";
import "./OutsourcePartner.css";
import case1 from "../outsourceassets/partner1.png";
import case2 from "../outsourceassets/partner3.png";
import case3 from "../outsourceassets/partner2.png";

export default function OutsourcePartner() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const cases = [
    {
      img: case1,
      name: "Delivery Excellence",
      text: "Over two decades of experience in implementing DevOps automation services",
    },
    {
      img: case2,
      name: "Lean Thinking",
      text: "Metrics-driven automation approach to derive maximum outcomes and value",
    },
    {
      img: case3,
      name: "DevOps DNA",
      text: "Seasoned professionals with an in-built DevOps mindset and agile orientation",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="outsourcing-partner" className="outsourcemainclass">
      <h2 className="heading">
        BastionEx as Your DevOps Automation Consulting Partner{" "}
      </h2>
      <p className="subheading">
        Driving intelligent automation and insights across diverse industry
        domains
      </p>

      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 12) / cardsToShow
                  }px)`,
                }}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {maxSlides > 0 && (
          <div className="carousel-dots">
            {Array.from({ length: maxSlides + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}